<template>
	<div
		class="search-result-room"
		@mouseenter="handleHover(true)"
		@mouseleave="handleHover(false)"
		@click="handleClick"
	>
		<div
			class="search-result-room__circle"
			:style="{backgroundColor: getRoomBGColor(data)}"
		>
			<img v-if="isDesktop" :src="getRoomBGImage(data)" />
		</div>
		<div class="search-result-room__name">{{data.name}}</div>
		<div class="search-result-room__online">{{data.online}}</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
	props: {
		data: Object
	},
	computed: {
		...mapGetters(['getRoomBGColor', 'getRoomBGImage']),
		...mapGetters('viewport', ['isDesktop']),
	},
	methods: {
		...mapActions(['routing/goToViewRoom', 'search/clear']),
		handleHover(on){
			this.$store.commit('search/HIGHLIGHTED_ROOM', on ? this.data.id : '');
		},
		handleClick() {
			this['search/clear']();
			this['routing/goToViewRoom'](this.data.id);
		}
	}
}
</script>

<style lang="scss" scoped>
.search-result-room {
	position: relative;
	display: flex;
	flex-flow: column;
	background-color: #201F1F;
	padding: 10px;
	border-radius: 17px;
	font-size: 14px;
	box-shadow: 0px 0px 4px #00000040;
	color: white;
	transition: background-color 0.5s;
	padding-left: 95px;
	overflow: hidden;
	min-height: 80px;
	cursor: pointer;
	box-sizing: border-box;

	&:hover {
		background-color: #414141;
	}

	&__circle {
		width: 100px;
		height: 100px;
		position: absolute;
		background-color: grey;
		top: 50%;
		transform: translateY(-50%);
		left: -20px;
		border-radius: 50%;
		overflow: hidden;
	}

	&__name {
		font-weight: bold;
		font-size: 16px;
		flex-grow: 1;
		line-height: 1.33;
	}
	&__online {
		font-size: 11px;
	}
}
</style>
